export default __webpack_public_path__ + "static/media/tour-3.e87cba7e.jpg";